import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdAnnotationsOptions, getEntitiesByFpIdBusinessOwnersOptions, getEntitiesByFpIdDocumentsOptions, getEntitiesByFpIdLabelOptions, getEntitiesByFpIdOnboardingsOptions, getEntitiesByFpIdReviewsOptions, getEntitiesByFpIdTagsOptions } from '@onefootprint/fetch-dashboard';
import { getLogger } from '@onefootprint/logger';
import { useQueries, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import useEntityVault from '../../../hooks/use-entity-vault';
import { useEntityContext } from '../hooks/use-entity-context';
import useAutoDecryptControls from './use-auto-decrypt-controls';
import useCurrentEntity from './use-current-entity';
import { transformDocuments } from './use-documents';
import useEntityDeviceInsights from './use-entity-device-insights';
import useEntityId from './use-entity-id';
import useEntityOtherInsights from './use-entity-other-insights';
import useEntityOwnedBusinesses from './use-entity-owned-businesses';
import useEntityTimeline from './use-entity-timeline';
const {
  logError
} = getLogger({
  location: 'use-entity-initial-data'
});
const usePrefetchNonCriticalQueries = (id, isBusiness) => {
  const $ = _c(5);
  useEntityDeviceInsights(id);
  useEntityOtherInsights(id);
  useEntityOwnedBusinesses(id);
  let t0;
  if ($[0] !== id) {
    t0 = getEntitiesByFpIdBusinessOwnersOptions({
      path: {
        fpId: id
      }
    });
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = isBusiness && !!id;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useQuery(t2);
};
const useEntityInitialData = () => {
  const $ = _c(54);
  const id = useEntityId();
  const {
    kind
  } = useEntityContext();
  const isBusiness = kind === "business";
  const entityQuery = useCurrentEntity();
  const t0 = entityQuery.data?.data;
  let t1;
  if ($[0] !== id || $[1] !== t0) {
    t1 = {
      entityAttributes: t0,
      entityId: id
    };
    $[0] = id;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const entityVaultQuery = useEntityVault(t1);
  const entityTimelineQuery = useEntityTimeline(id);
  let t2;
  if ($[3] !== id) {
    t2 = getEntitiesByFpIdReviewsOptions({
      path: {
        fpId: id
      }
    });
    $[3] = id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = !!id;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      ...t2,
      enabled: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== id) {
    t5 = getEntitiesByFpIdDocumentsOptions({
      path: {
        fpId: id
      }
    });
    $[8] = id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      ...t5,
      select: transformDocuments
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== id) {
    t7 = getEntitiesByFpIdTagsOptions({
      path: {
        fpId: id
      }
    });
    $[12] = id;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = !!id;
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = {
      ...t7,
      enabled: t8
    };
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== id) {
    t10 = getEntitiesByFpIdLabelOptions({
      path: {
        fpId: id
      }
    });
    $[17] = id;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = !!id;
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = {
      ...t10,
      enabled: t11
    };
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== id) {
    t13 = getEntitiesByFpIdAnnotationsOptions({
      path: {
        fpId: id
      }
    });
    $[22] = id;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = !!id;
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = {
      ...t13,
      enabled: t14
    };
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== id) {
    t16 = getEntitiesByFpIdOnboardingsOptions({
      path: {
        fpId: id
      }
    });
    $[27] = id;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = !!id;
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = {
      ...t16,
      enabled: t17
    };
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t12 || $[33] !== t15 || $[34] !== t18 || $[35] !== t4 || $[36] !== t6 || $[37] !== t9) {
    t19 = {
      queries: [t4, t6, t9, t12, t15, t18]
    };
    $[32] = t12;
    $[33] = t15;
    $[34] = t18;
    $[35] = t4;
    $[36] = t6;
    $[37] = t9;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const [reviewsPendingQuery, documentsQuery, tagsQuery, labelsQuery, annotationsQuery, onboardingsQuery] = useQueries(t19);
  const isPending = [entityQuery.isPending, annotationsQuery.isPending, tagsQuery.isPending, labelsQuery.isPending, entityVaultQuery.isPending, reviewsPendingQuery.isPending, documentsQuery.isPending, entityTimelineQuery.isPending, onboardingsQuery.isPending].some(Boolean);
  usePrefetchNonCriticalQueries(id, isBusiness);
  const {
    enabled: autoDecryptEnabled,
    decrypt: autoDecrypt,
    isEntityAutoDecrypting
  } = useAutoDecryptControls(kind);
  let t20;
  if ($[39] !== autoDecrypt || $[40] !== autoDecryptEnabled || $[41] !== documentsQuery.data || $[42] !== entityQuery.data || $[43] !== entityVaultQuery || $[44] !== isEntityAutoDecrypting) {
    t20 = () => {
      const entity = entityQuery.data;
      const documents = documentsQuery.data;
      const vaultData = entityVaultQuery.data;
      const isDataReady = entity && documents && vaultData;
      const isAutoDecrypting = isEntityAutoDecrypting(entity?.id);
      if (autoDecryptEnabled && isDataReady && !isAutoDecrypting) {
        autoDecrypt({
          entity,
          documents,
          vaultData
        }).then(response => {
          if (response) {
            entityVaultQuery.update({
              vault: response,
              transforms: {},
              dataKinds: {}
            });
          } else {
            logError("Vault decryption error", undefined, {
              entityId: entity.id,
              detail: "No response in useEntityInitialData autodecryption"
            });
          }
        });
      }
    };
    $[39] = autoDecrypt;
    $[40] = autoDecryptEnabled;
    $[41] = documentsQuery.data;
    $[42] = entityQuery.data;
    $[43] = entityVaultQuery;
    $[44] = isEntityAutoDecrypting;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  const t21 = entityQuery.data?.id;
  let t22;
  if ($[46] !== autoDecryptEnabled || $[47] !== documentsQuery.data || $[48] !== entityVaultQuery.data || $[49] !== t21) {
    t22 = [autoDecryptEnabled, t21, documentsQuery.data, entityVaultQuery.data];
    $[46] = autoDecryptEnabled;
    $[47] = documentsQuery.data;
    $[48] = entityVaultQuery.data;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  useEffect(t20, t22);
  let t23;
  if ($[51] !== entityQuery || $[52] !== isPending) {
    t23 = {
      ...entityQuery,
      isPending
    };
    $[51] = entityQuery;
    $[52] = isPending;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  return t23;
};
export default useEntityInitialData;